import { render } from "./DetailsResidence.vue?vue&type=template&id=393b630d&scoped=true"
import script from "./DetailsResidence.vue?vue&type=script&lang=js"
export * from "./DetailsResidence.vue?vue&type=script&lang=js"

import "./DetailsResidence.vue?vue&type=style&index=0&id=393b630d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393b630d"]])

export default __exports__